import { doRequestPost } from '../../../api';
import { setSecondToExpire, setSessionCustomer } from './sessionCustomerSlice';

export const getSessionCustomer = () => {
  return async (dispatch) => {
    try {
      const userSession = await doRequestPost({
        url: '/event/customer/generate/id',
        data: {
          p_id_customers: localStorage.getItem('session-customer-storage') ? localStorage.getItem('session-customer-storage') : null,
        }
      })

      if (userSession.response === 'success') {
        dispatch(setSessionCustomer({
          id_customers_reservation_event_zone: userSession.data.id,
        }));
      }
    } catch (error) {
    }
  }
}

export const setCustomerTime = () => {
  return async (dispatch) => {
    try {
      const getTimeSeconds = await doRequestPost({
        url: '/event/customer/time/' + localStorage.getItem('session-customer-storage'),
      })

      dispatch(setSecondToExpire({
        seconds_to_expire: getTimeSeconds.response === 'success' ? getTimeSeconds.data.date_reservation_event_zone : 0,
      }));
    } catch (error) {
    }
  }
}